<template>
    <div id="listGLAccount">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> GL Account List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAddGl" class="btn btn-primary" v-bind:to="{name: 'GLAccountCreate'}"> <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content gl-account-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <template v-for="(acType, index) in accountTypesArr" >
                                        <button type="button" :id="'tab_'+index" v-bind:key="acType.name+'_'+index" v-on:click="getGlAccounts(acType.value,index)" class="btn btn-secondary tab-buttons" :class="index == 0 ? 'active' : ''">
                                            {{acType.name}}
                                        </button>
                                    </template>
                                    <button type="button" :id="'tab_999'" v-bind:key="'all_999'" v-on:click="getGlAccounts('all',999)" class="btn btn-secondary tab-buttons">
                                        All
                                    </button>
                                    <!-- <button type="button" id="getAssetsType" v-on:click="getAssetsType(this)" :class="'btn btn-secondary '+ assetActive"> Assets </button>
                                    <button type="button" id="getEquityType" v-on:click="getEquityType(this)" :class="'btn btn-secondary '+ equityActive"> Equity </button>
                                    <button type="button" id="getLiabilitiesType" v-on:click="getLiabilitiesType(this)" :class="'btn btn-secondary '+ liabilitiesActive"> Liabilities </button>
                                    <button type="button" id="getRevenueType" v-on:click="getRevenueType(this)" :class="'btn btn-secondary '+ revenueActive"> Revenue </button>
                                    <button type="button" id="getSuspenseType" v-on:click="getSuspenseType(this)" :class="'btn btn-secondary '+ suspenseActive"> Suspense </button>
                                    <button type="button" id="getExpenseType" v-on:click="getExpenseType(this)" :class="'btn btn-secondary '+ expenseActive"> Expense </button> -->
                                </div>
                            </div>
                            <!-- <div class="mobile-action-btn">
                                <select class="selectpicker">
                                    <optgroup>
                                        <option>
                                            <button type="button" id="getAssetsType" v-on:click="getAssetsType(this)" :class="'btn btn-secondary '+ assetActive"> Assets </button>
                                        </option>
                                        <option>
                                            <button type="button" id="getEquityType" v-on:click="getEquityType(this)" :class="'btn btn-secondary '+ equityActive"> Equity </button>
                                        </option>
                                        <option>
                                            <button type="button" id="getLiabilitiesType" v-on:click="getLiabilitiesType(this)" :class="'btn btn-secondary '+ liabilitiesActive"> Liabilities </button>
                                        </option>
                                        <option>
                                            <button type="button" id="getRevenueType" v-on:click="getRevenueType(this)" :class="'btn btn-secondary '+ revenueActive"> Revenue </button>
                                        </option>
                                        <option>
                                            <button type="button" id="getSuspenseType" v-on:click="getSuspenseType(this)" :class="'btn btn-secondary '+ suspenseActive"> Suspense </button>
                                        </option>
                                        <option>
                                            <button type="button" id="getExpenseType" v-on:click="getExpenseType(this)" :class="'btn btn-secondary '+ expenseActive"> Expense </button>
                                        </option>
                                    </optgroup>
                                </select>
                            </div> -->
                        </div>
                        <!-- Button for Clear Cache -->

                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'glAccountsList'" ref="filterGlaccount" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'glAccountsList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listGLAccountsTable"
                                      mode="remote"
                                      title="GLAccounts"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: gl_account_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                      <router-link v-if="canUpdateGl" title="Edit GLAccount" class="fp-edit" v-bind:to="{name: 'GLAccountEdit',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <!-- <div slot="selected-row-actions">
                                              <button v-if="gl_account_value" id="deleteGLAccountBtn" v-on:click.prevent="glAccountDelete" class="btn btn-danger">Delete</button>
                                      </div> -->
                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import { contractMixins } from '../../mixins/contractMixins';

export default {
    name: "GLAccountList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "GL Account List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[contractMixins,commonMixins,dataTableMixins],
    data: () => ({
        firstLoad : 0,
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: 'Company',
                field: 'company',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Company", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Code',
                field: 'code',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Description',
                field: 'description',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            /*{
                label: 'Account Type',
                field: 'account_type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Account Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },*/
            {
                label: 'Facility',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Facility", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Natural Acct',
                field:'natural_account',
                fpFieldType:"text",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Natural Acct", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        accountTypesArr:[],
        totalRecords: 0,
        permissions:[],
        loading:false,
        action:"list",
        cantAccessPage:"",
        gl_account_value:false,
        canAddGl:false,
        canUpdateGl:false,
        assetActive:'active',
        equityActive:'',
        liabilitiesActive:'',
        revenueActive:'',
        suspenseActive:'',
        expenseActive:'',
        accountType:'',
        pageKey:"_gl_account_list_",
        // firstLoad: 0,
        batchProcess:0,
        batchNum:"",
        filterAll:[],
    }),
    watch:{

        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_gl_account') {
                    self.cantAccessPage = true;
                }
                if (permissions.name == 'delete_gl_account') {
                    self.gl_account_value = true;
                }
                 if (permissions.name == 'add_gl_account') {
                    self.canAddGl = true;
                    self.canUpdateGl = true;
                }

            });
        },

        accountTypesArr(typeArr) {
            var prevSelectedTab = localStorage.getItem("gl_list_prev_tab");

            if (prevSelectedTab != null){
                if(prevSelectedTab == '999'){
                    var value = 'all';
                }else{
                    var value = parseInt(prevSelectedTab) + 1;
                }
                this.$nextTick(() => {
                    this.getGlAccounts(value,prevSelectedTab);
                });
            }else{
                this.$nextTick(() => {
                    this.getGlAccounts(typeArr[0].value,0);
                });
            }
        }
    },
    created: function() {
        var self = this;
    },
    mounted: function () {

        this.getPermissions();
        this.loadFieldData(['accountTypes']);
    },
    methods: {
        cancelAll: function (cancelAll) {
            this.$refs.listGLAccountsTable.unselectAllInternal();
          },

        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            // console.log(self.computed.selectedRows);
            var rowData = self.$refs['listGLAccountsTable'].selectedRows;
            console.log(rowData);
        },
        getGlAccounts(acType,index) {

            setTimeout(function() {
                $(".tab-buttons").removeClass("active");
                $("#tab_" + parseInt(index)).addClass("active");
            }, 1000);
            localStorage.setItem('gl_list_prev_tab', index);

            this.accountType = acType;
            if ( self.firstLoad == 1 ) {
                this.$refs.filterGlaccount.onColumnFilter('cancel');
                this.loadList();
            }
            self.firstLoad=1;
        },
        exportCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listGLAccountsTable'].selectedRows;
            count = data.length;

            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }

            this.exportReports(actionFlag);
        },
        loadList() {
            var self = this;
            self.loading = true;
            var data = this.$refs['listGLAccountsTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listGLAccountsTable'].selectedRows[i].id)
            }

            self.filterAll = self.serverParams.columnFilters;
            if ( self.action == "export" ) {
                self.filterAll = self.removeOptionArr(self.serverParams.columnFilters);
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.filterAll,
                sort: self.serverParams.sort,
                action:self.action,
                all:self.serverParams.selectedAll,
                id:use,
                accountTypeId:self.accountType

            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/gl-account/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {

                        if (self.action == 'delete') {

                            self.action = "list";
                            self.$refs.filterGlaccount.clearSelectAll();

                            if(data.inUseGLAccount != ''){
                              self.$swal(data.message, data.inUseGLAccount, 'warning');
                            }else{
                              self.$swal('',data.message,'success');
                            }

                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();

                        } else {

                            if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (self.action =='export') {
                        self.generateStatusCodeMessage(jqXHR,true,'glaccount-export');
                    }else{
                        self.generateStatusCodeMessage(jqXHR,false,'glaccount-list');
                    }
                }
            });
        },
        // glAccountDelete() {

        //     var self = this;
        //     self.$swal({
        //             title: 'Are you sure that you want to delete this GL Account?',
        //             type: 'info',
        //             showCancelButton: true,
        //             confirmButtonText: 'Yes',
        //             cancelButtonText: 'No',
        //             showCloseButton: false,
        //             showLoaderOnConfirm: true
        //         }).then((result) => {
        //             if (result.value) {
        //                  self.action = 'delete';
        //                  self.loadList();
        //             } else {
        //               console.log("no");
        //             }
        //         });
        // },
        getAssetsType() {
            var self = this;
            self.assetActive = 'active';
            self.equityActive = '';
            self.liabilitiesActive = '';
            self.revenueActive = '';
            self.suspenseActive = '';
            self.expenseActive = '';
            self.accountType = 'A';
            //clear filters and load list

        },
        getEquityType() {
            var self = this;
            self.assetActive = '';
            self.equityActive = 'active';
            self.liabilitiesActive = '';
            self.revenueActive = '';
            self.suspenseActive = '';
            self.expenseActive = '';
            self.accountType = 'E';
            //clear filters and load list
            self.$refs.filterGlaccount.onColumnFilter('cancel');
            self.loadList();
        },
        getLiabilitiesType() {
            var self = this;
            self.assetActive = '';
            self.equityActive = '';
            self.liabilitiesActive = 'active';
            self.revenueActive = '';
            self.suspenseActive = '';
            self.expenseActive = '';
            self.accountType = 'L';
            //clear filters and load list
            self.$refs.filterGlaccount.onColumnFilter('cancel');
            self.loadList();
        },
        getRevenueType() {
            var self = this;
            self.assetActive = '';
            self.equityActive = '';
            self.liabilitiesActive = '';
            self.revenueActive = 'active';
            self.suspenseActive = '';
            self.expenseActive = '';
            self.accountType = 'R';
            //clear filters and load list
            self.$refs.filterGlaccount.onColumnFilter('cancel');
            self.loadList();
        },
        getSuspenseType() {
            var self = this;
            self.assetActive = '';
            self.equityActive = '';
            self.liabilitiesActive = '';
            self.revenueActive = '';
            self.suspenseActive = 'active';
            self.expenseActive = '';
            self.accountType = 'S';
            //clear filters and load list
            self.$refs.filterGlaccount.onColumnFilter('cancel');
            self.loadList();
        },
        getExpenseType() {
            var self = this;
            self.assetActive = '';
            self.equityActive = '';
            self.liabilitiesActive = '';
            self.revenueActive = '';
            self.suspenseActive = '';
            self.expenseActive = 'active';
            self.accountType = 'X';
            //clear filters and load list
            self.$refs.filterGlaccount.onColumnFilter('cancel');
            self.loadList();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/accounting/GLAccountList.vue